import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AlertifyService } from 'src/app/services/alertify.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-listado-administradores',
  templateUrl: './listado-administradores.component.html',
  styleUrls: ['./listado-administradores.component.scss'],
})
export class ListadoAdministradoresComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  constructor(
    private usrSvc: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alertify: AlertifyService,
    private dialogRef: MatDialogRef<ListadoAdministradoresComponent>
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = ['nombre', 'email', 'celular', 'botones'];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }

  ngOnInit(): void {
    this.getAdministradores();
  }

  getAdministradores() {
    this.isLoadingResults = true;
    this.usrSvc.listadoAdministradores(this.data).subscribe((result) => {
      this.dataSource = new MatTableDataSource<any>(result);
      this.isLoadingResults = false;
      console.log('resultado: ', result);
      //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
    });
  }

  reenviarInvitacion(admin: any) {
    this.usrSvc.reenviarEmailActivacion(admin.id).subscribe((result) => {
      if (result) {
        this.alertify.success('invitación enviada');
        this.dialogRef.close();
      } else {
        this.alertify.error(
          'Error al enviar la invitación, contacte con el administrador del sistema'
        );
      }
    });
  }
}
